"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var stylesForDarkBackground = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0.325rem 0;\n  margin-bottom: 2.75rem;\n  background: linear-gradient(\n    to left,\n    transparent 0%,\n    ", " 10%,\n    ", " 90%,\n    transparent 100%\n  );\n  color: ", ";\n"])), function (p) {
  return (0, _polished.rgba)(p.theme.colorDark, 0.75);
}, function (p) {
  return (0, _polished.rgba)(p.theme.colorDark, 0.75);
}, function (p) {
  return p.theme.colorDarkText;
});

var StyledWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 80%;\n  margin: 0 auto 2.5rem;\n  padding: 0 0 1.75rem;\n  font-family: ", ";\n  font-size: 1.5rem;\n  text-align: center;\n  color: ", ";\n  background: transparent;\n\n  ", ";\n"])), function (p) {
  return p.theme.fontFamilySpecial;
}, function (p) {
  return p.theme.colorLabel;
}, process.env.REACT_APP_BACKGROUND_IMAGE && stylesForDarkBackground);

var ContestMakePicks = function ContestMakePicks() {
  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      translations = _useSelector.translations;

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: translations.makeYourPicks
  });
};

var _default = ContestMakePicks;
exports.default = _default;